import { render, staticRenderFns } from "./ProjectDescription.vue?vue&type=template&id=73802cce&scoped=true&"
import script from "./ProjectDescription.vue?vue&type=script&lang=js&"
export * from "./ProjectDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73802cce",
  null
  
)

export default component.exports